<template>
  <HMModalContainer :isStudioPage="true">
    <div class="text-center" v-if="isLoading">
      <HMSpinner></HMSpinner>
    </div>
    <div v-else class="text-center">
      <h1 v-if="user" class="mb-4">
        {{ $t('GENERAL.LABEL.HI_NAME', { name: user.user_full_name }) }}
      </h1>
      <div v-if="waiver.id && !waiverAccepted">
        <h1 class="mb-4">
          {{ $t('WAIVER.TITLE.ACCEPT_WAIVER') }}
        </h1>
        <LegalWaiverModal
          :waiver="waiver"
          :uuid="uuid"
          @onSubmit="waiverAccepted = true"
          class="p-0"
        />
      </div>
      <div v-else>
        <div class="text-center">
          <h2 v-if="waiverAccepted" class="mb-4">
            {{ $t('WAIVER.TEXT.WAIVER_SUCCESSFULLY_ACCEPTED') }}
          </h2>
          <h2 v-else class="mb-4">
            {{ $t('WAIVER.TEXT.WAIVER_ALREADY_ACCEPTED') }}
          </h2>
          <HMButton color="brand">
            <router-link
              class="undecorated-router-link"
              :to="{ name: 'studio-home-page' }"
            >
              {{ $t('GENERAL.BUTTON.RETURN_TO_STUDIO') }}
            </router-link>
          </HMButton>
        </div>
      </div>
    </div>
  </HMModalContainer>
</template>

<script>
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import HMSpinner from '@/web/components/common/HMSpinner.vue';
import LegalWaiverModal from '@/web/components/shop/LegalWaiverModal.vue';

export default {
  name: 'StudentAcceptWaiver',
  components: {
    HMSpinner,
    LegalWaiverModal,
  },
  data() {
    return {
      isLoading: true,
      user: null,
      waiver: null,
      waiverAccepted: false,
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      isLoggedIn: 'user/isLoggedIn',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    uuid() {
      return this.$route.params.uuid;
    },
  },
  methods: {
    async loadData() {
      if (!this.isLoggedIn && !this.uuid) return;
      this.isLoading = true;
      try {
        if (this.uuid) {
          this.user = await this.$store.dispatch(
            'user/getUserByUUID',
            this.uuid
          );
        }
        this.waiver = await this.$store.dispatch('studio/getWaiverToBeSigned', {
          studioURL: this.studioURL,
          uuid: this.uuid,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t(
            'UNSUBSCRIBE.NOTIFICATIONS.FAILED_TO_LOAD_USER_WITH_THIS_TOKEN'
          ),
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    isLoggedIn: {
      handler() {
        if (this.isLoggedIn) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
};
</script>
